<div class="file-input-container m-t-4 text-center">
    <div (fileOver)="fileOverDropZone($event)" *ngIf="!disabled" [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (paste)="onPaste($event)"
         [uploader]="fileUploader" class="drop-zone" ng2FileDrop>
        Déposez le fichier ici {{extensionsAsText}}
  </div>

    <label *ngIf="!disabled">
    <input type="file" ng2FileSelect [uploader]="fileUploader" />
        Ajouter un fichier {{extensionsAsText}}
  </label>
</div>
<div *ngIf="fileUploader.queue.length > 0">
  <h5><ion-text color="primary">Fichiers joints</ion-text></h5>
  <p>
    <span *ngFor="let queueElement of fileUploader.queue">{{queueElement.file?.name}} <br/></span>
  </p>
</div>
